import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Notify } from 'notiflix/build/notiflix-notify-aio';
import { useGoogleReCaptcha } from '@google-recaptcha/react';
import PropTypes from 'prop-types';

import appSelectors from '@/redux/app/appSelectors';
import discountSelectors from '@/redux/discount/discountSelectors';

import { setDisplayModal } from '@/redux/app/appSlice';
import {
  setDiscountPrize,
  setSendDiscountStatus,
} from '@/redux/discount/discountSlice';

import discountOperations from '@/redux/discount/discountOperations';

import image2 from '@/images/modalPromocode/image-step-2.webp';
import image3 from '@/images/modalPromocode/image-step-3.webp';

import Modal from '@/ui/modal';
import Input from '@/ui/input';

import Roulette from './roulette';

import s from './modalPromocode.module.css';

function ModalPromocode({ close, type }) {
  const dispatch = useDispatch();

  const i18n = useSelector(appSelectors.translation);
  const language = useSelector(appSelectors.language);
  const discountsVps = useSelector(discountSelectors.vps);
  const discountsMonitoring = useSelector(discountSelectors.monitoring);
  const prize = useSelector(discountSelectors.prize);
  const sendStatus = useSelector(discountSelectors.sendStatus);

  const { executeV3 } = useGoogleReCaptcha();

  const [step, setStep] = useState(1);
  const [startCarousel, setStartCarousel] = useState(false);
  const [email, setEmail] = useState('');

  const [recaptchaToken, setRecaptchaToken] = useState('');
  console.log('Recaptcha token:', recaptchaToken);

  // Create an event handler so you can call the verification on button click event or form submit
  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeV3) {
      console.log('Execute recaptcha not available');
      return;
    }

    const token = await executeV3();

    setRecaptchaToken(token);
  }, [executeV3]);

  const closeModal = () => {
    setStep(1);
    setEmail('');

    dispatch(setDiscountPrize(null));
    dispatch(setSendDiscountStatus(''));

    dispatch(setDisplayModal(false));

    close();
  };

  const goStep2 = () => {
    setStartCarousel(true);

    setTimeout(() => {
      setStep(2);
      setStartCarousel(false);
    }, 3000);
  };

  const sendDiscount = e => {
    e.preventDefault();
    e.stopPropagation();

    if (!recaptchaToken) {
      Notify.warning('Google recaptcha is required');
      return;
    }

    if (!email) {
      Notify.warning(i18n.Введите_ваш_email);
      return;
    }

    const data = {
      email,
      promo_id: prize?.promo_id,
      language,
    };

    dispatch(discountOperations.sendDiscount(data));
  };

  // You can use useEffect to trigger the verification as soon as the component being loaded
  useEffect(() => {
    handleReCaptchaVerify();
  }, [handleReCaptchaVerify]);

  useEffect(() => {
    if (
      (type === 'vps' && !discountsVps) ||
      (type === 'monitoring' && !discountsMonitoring)
    )
      dispatch(discountOperations.getDiscounts());
  }, [discountsMonitoring, discountsVps, dispatch, type]);

  useEffect(() => {
    dispatch(discountOperations.getPrize(type));
  }, [dispatch, type]);

  useEffect(() => {
    if (sendStatus === 'success') {
      setStep(3);
      return;
    }

    if (sendStatus === 'failure') {
      Notify.warning(i18n.Ошибка_отправки_email);
      dispatch(setSendDiscountStatus(''));
      return;
    }

    if (sendStatus) {
      Notify.warning(sendStatus);
      dispatch(setSendDiscountStatus(''));
    }
  }, [dispatch, sendStatus, i18n]);

  return (
    <Modal close={closeModal}>
      {step === 1 && (
        <>
          <p className={s.title}>{i18n.промокод}</p>
          <p className={s.text}>
            {i18n.вы_можете_получить_промокод},
            <br />
            {i18n.сделав_один_спин}!
          </p>
          <div className={s.roulette}>
            {((type === 'vps' && discountsVps) ||
              (type === 'monitoring' && discountsMonitoring)) &&
              prize && (
                <Roulette
                  discounts={
                    type === 'vps' ? discountsVps : discountsMonitoring
                  }
                  prize={prize}
                  startCarousel={startCarousel}
                />
              )}
          </div>
          <button
            type="button"
            onClick={goStep2}
            className={s.btn_ok}
            disabled={startCarousel}
          >
            {i18n.начать}
          </button>
        </>
      )}
      {step === 2 && (
        <>
          <img src={image2} alt="prize" className={s.img} loading="lazy" />
          <p className={s.title}>{i18n.поздравляем}!</p>
          <p className={s.text}>
            {i18n.вы_получили_промокод_на} <span>{prize?.discount}%.</span>
          </p>
          <p className={s.text}>{i18n.напишите_адрес_электронной}</p>
          <form onSubmit={sendDiscount} className={s.form}>
            <Input
              type="email"
              id="modalDiscountVps"
              placeholder="e-mail"
              value={email}
              onChange={setEmail}
            />
            <button type="submit" className={s.btn_ok}>
              {i18n.отправить}
            </button>
          </form>
        </>
      )}
      {step === 3 && (
        <>
          <img src={image3} alt="email" className={s.img} loading="lazy" />
          <p className={s.title}>{i18n.успешно}!</p>
          <p className={s.text}>
            {i18n.Промокод_на} <span>{prize?.discount}%</span>{' '}
            {i18n.был_направлен_на}
          </p>
          <button type="button" onClick={closeModal} className={s.btn_close}>
            {i18n.закрыть}
          </button>
        </>
      )}
    </Modal>
  );
}

export default ModalPromocode;

ModalPromocode.propTypes = {
  close: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};
